import Axios from 'axios';

export const getFile = () => Axios.get(`${window.location.origin}${window.location.pathname}static/privacy/privacy.json`);
